import moment from 'moment'

export const sortByDate = (key = 'date') => (first, second) => {
  return first[key] > second[key] ? -1 : second[key] > first[key] ? 1 : 0
}

export const transformDisponibility = (daytime, date) => {
  const from = moment(date)
  const to = moment(date)
  switch (daytime) {
  case 'full':
    from.hour(8)
    to.hour(19)
    return { from: from.unix(), to: to.unix() }
  case 'am':
    from.hour(8)
    to.hour(13)
    return { from: from.unix(), to: to.unix() }
  case 'pm':
    from.hour(13)
    to.hour(19)
    return { from: from.unix(), to: to.unix() }
  default:
    return { from: from.unix(), to: to.unix() }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/dates.js